export const getEmailsBegin = "GET_EMAILS_BEGIN";
export const getEmailsSuccess = "GET_EMAILS_SUCCESS";
export const getEmailsFailure = "GET_EMAILS_FAILURE";
export const getEmailsLazyBegin = "GET_EMAILS_LAZY_BEGIN";
export const getEmailsLazySuccess = "GET_EMAILS_LAZY_SUCCESS";
export const getEmailsLazyFailure = "GET_EMAILS_LAZY_FAILURE";
export const resetEmails = "RESET_EMAILS";
